import React from "react";

const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
    <path fill="#4285F4" d="M17.64 9.2045c0-.6381-.0573-1.2518-.1636-1.8409H9v3.4814h4.8436c-.2086 1.125-.8427 2.0782-1.7959 2.7164v2.2582h2.9082c1.7018-1.5668 2.6841-3.874 2.6841-6.6151z" />
    <path fill="#34A853" d="M9 18c2.43 0 4.4673-.806 5.9564-2.1805l-2.9082-2.2582c-.8059.54-1.8368.859-3.0482.859-2.344 0-4.3282-1.5831-5.036-3.7104H.9573v2.3318C2.4382 15.9832 5.4818 18 9 18z" />
    <path fill="#FBBC05" d="M3.964 10.71c-.18-.54-.2822-1.1168-.2822-1.71s.1023-1.17.2822-1.71V4.9582H.9573C.3477 6.1732 0 7.5477 0 9s.3477 2.8268.9573 4.0418L3.964 10.71z" />
    <path fill="#EA4335" d="M9 3.5795c1.3214 0 2.5077.4541 3.4405 1.346l2.5813-2.5814C13.4632.8918 11.426 0 9 0 5.4818 0 2.4382 2.0168.9573 4.9582L3.964 7.29C4.6718 5.1627 6.656 3.5795 9 3.5795z" />
  </svg>
);

export const GoogleAuthButton = ({ label = "Continue with Google", onClick, disabled }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    data-testid="google-auth-button"
    className="w-full flex items-center justify-center gap-3 h-11 rounded-md border border-slate-300 bg-white text-slate-700 font-medium text-sm shadow-sm transition-colors hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500/40 disabled:opacity-60 disabled:cursor-not-allowed"
  >
    <GoogleIcon />
    <span>{label}</span>
  </button>
);

export const OrDivider = () => (
  <div className="relative my-5" data-testid="auth-divider">
    <div className="absolute inset-0 flex items-center">
      <span className="w-full border-t border-slate-200" />
    </div>
    <div className="relative flex justify-center">
      <span className="bg-white px-3 text-xs uppercase tracking-wide text-slate-400">or</span>
    </div>
  </div>
);

export default GoogleAuthButton;
